import styled, {
    css,
    device,
    layout,
    space,
    themeGet,
    typography,
} from "@styled";
import { allowedTags } from "@utils";

export const StyledSectionTitle = styled("div").withConfig({
    shouldForwardProp: (prop, defaultValidatorFn) =>
        ![...allowedTags].includes(prop) && defaultValidatorFn(prop),
})`
    ${typography};
    ${space};
    ${layout}
`;

export const StyledTitle = styled.h3`
    font-size: ${themeGet("fontSizes.h2")};
    line-height: 1.25em;

    ${({ $layout }) =>
        $layout === 2 &&
        css`
            margin-block-end: 10px;
            ${device.medium} {
                margin-block-end: 20px;
            }
        `}
    span {
        color: ${themeGet("colors.primary")};
    }
`;

export const StyledSubtitle = styled.h6`
    color: ${themeGet("colors.textSecondary")};
    font-weight: 400;
    font-size: ${themeGet("fontSizes.h5")};

    ${({ $layout }) =>
        $layout === 1 &&
        css`
            margin-block-start: -5px;
            margin-block-end: 10px;
            line-height: 1.43;
            ${device.medium} {
                margin-block-end: 20px;
            }
        `}
`;

export const StyledDesc = styled.p`
    margin-block-start: 20px;
    ${device.medium} {
        margin-block-start: 30px;
    }
    ${space}
`;
